function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H24V24H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#808285",
  d: "M.563-7.657a1.968 1.968 0 0 1 1.431-.6A1.928 1.928 0 0 1 3.4-7.68a1.922 1.922 0 0 1 .587 1.419A1.922 1.922 0 0 1 3.4-4.843a1.928 1.928 0 0 1-1.408.581 1.928 1.928 0 0 1-1.405-.581A1.922 1.922 0 0 1 0-6.262a1.885 1.885 0 0 1 .563-1.395zm12.012 0a1.968 1.968 0 0 1 1.431-.6 1.928 1.928 0 0 1 1.408.581A1.922 1.922 0 0 1 16-6.262a1.922 1.922 0 0 1-.587 1.419 1.928 1.928 0 0 1-1.408.581 1.928 1.928 0 0 1-1.405-.581 1.922 1.922 0 0 1-.587-1.419 1.885 1.885 0 0 1 .562-1.395zm-6.006 0A1.968 1.968 0 0 1 8-8.262a1.928 1.928 0 0 1 1.408.581 1.922 1.922 0 0 1 .587 1.419 1.922 1.922 0 0 1-.587 1.419A1.928 1.928 0 0 1 8-4.262a1.928 1.928 0 0 1-1.408-.581 1.922 1.922 0 0 1-.587-1.419 1.885 1.885 0 0 1 .564-1.395z",
  transform: "translate(4 18.262)"
});

function SvgIconActionMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActionMenu);
export default __webpack_public_path__ + "static/media/iconActionMenu.e8f6b826.svg";
export { ForwardRef as ReactComponent };